import angular from 'angular'
import React from 'react'
import ReactDOM from 'react-dom'

import LineConfiguration from '~/reactapp/Settings/LineConfiguration'

const templateId = 'react-LineConfiguration'

function Link(scope, el) {
  const rootEl = el[0]

  scope.$on('$destroy', () => ReactDOM.unmountComponentAtNode(rootEl))

  scope.vm.render = (props) => {
    ReactDOM.render(<LineConfiguration {...props} />, rootEl)
  }
}

function Controller() {
  const handleChange = (websiteLineConfig) => {
    this.onChange({ websiteLineConfig })
  }

  const handleDelete = (websiteName) => {
    this.onDelete({ websiteName })
  }

  this.$onChanges = () => {
    this.render &&
      this.companySettings.lineSettings &&
      this.websites &&
      this.render({
        lineSettings: this.companySettings.lineSettings,
        websites: Object.keys(this.websites),
        onChange: handleChange,
        onDelete: handleDelete,
      })
  }
}

function directive() {
  return {
    replace: true,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: true,
    template: `<div id="${templateId}"/>`,
    scope: {
      companySettings: '<',
      websites: '<',
      onChange: '&',
      onDelete: '&',
    },
    controller: Controller,
    link: Link,
  }
}

export default angular
  .module('ellipsis.lineConfiguration', [])
  .directive('lineConfiguration', directive)
